import {
  FacilityType,
  WorkingHour,
  ShiftModel,
  LanguageLevel,
  DriversLicense,
  FurtherEducation,
  Position,
  ContractType,
  Benefit,
  Requirement
} from "./types";

export const facilityTypes: FacilityType[] = [
  { value: "hospital", label: "Krankenhaus" },
  { value: "nursing_home", label: "Pflegeheim" },
  { value: "ambulatory_care", label: "Ambulante Pflege" },
  { value: "day_care", label: "Tagespflege" },
  { value: "intensive_care", label: "Außerklinische Intensivpflege" },
  { value: "emergency_service", label: "Rettungsdienst" },
  { value: "rehabilitation", label: "Rehabilitation" },
  { value: "doctor_office", label: "Arztpraxis" },
  { value: "hospice", label: "Hospiz" },
  { value: "clinic", label: "Klinik" }
];

export const workingHours: WorkingHour[] = [
  { value: "full_time", label: "Vollzeit" },
  { value: "part_time_75", label: "Teilzeit (75%)" },
  { value: "part_time_50", label: "Teilzeit (50%)" },
  { value: "part_time", label: "Teilzeit" },
  { value: "minijob", label: "Minijob" },
  { value: "shift_work", label: "Schichtdienst" },
  { value: "flexible", label: "Flexibel" }
];

export const shiftModels: ShiftModel[] = [
  { value: "12h", label: "12-Stunden-Dienste" },
  { value: "10h", label: "10-Stunden-Dienste" },
  { value: "8h", label: "8-Stunden-Dienste" },
  { value: "6h", label: "6-Stunden-Dienste" },
  { value: "4h", label: "4-Stunden-Dienste" },
  { value: "early", label: "Frühdienst" },
  { value: "late", label: "Spätdienst" },
  { value: "night", label: "Nachtdienst" },
  { value: "weekend", label: "Wochenenddienst" }
];

export const languageLevels: LanguageLevel[] = [
  { value: "a1", label: "A1" },
  { value: "a2", label: "A2" },
  { value: "b1", label: "B1" },
  { value: "b2", label: "B2" },
  { value: "c1", label: "C1" },
  { value: "c2", label: "C2" }
];

export const driversLicenses: DriversLicense[] = [
  { value: "none", label: "Nein" },
  { value: "b", label: "B" },
  { value: "c1", label: "C1" },
  { value: "c", label: "C" }
];

export const furtherEducations: FurtherEducation[] = [
  { value: "none", label: "Keine Weiterbildung" },
  {
    value: "intensive_care",
    label: "Außerklinische Intensiv- und Beatumungspflege"
  },
  { value: "facility_management", label: "Heimleitung/Einrichtungsleitung" },
  { value: "anesthesia", label: "Intensiv- und Anästhesiepflege" },
  { value: "oncology", label: "Onkologie" },
  { value: "operation", label: "Operations- und Endoskopiedienst" },
  { value: "palliative", label: "Palliativpflege" },
  { value: "nursing_director", label: "Pflegedienstleitung" },
  { value: "practice_instructor", label: "Praxisanleitung" },
  { value: "psychiatry", label: "Psychiatrie / Gerontopsychiatrie" },
  { value: "quality_management", label: "Qualitätsmanagement" },
  { value: "area_management", label: "Wohnbereichsleitung" },
  { value: "wound_management", label: "Wundmanagement" }
];

export const positions: Position[] = [
  { value: "training", label: "Ausbildung" },
  { value: "assistant", label: "Hilfskraft" },
  { value: "specialist_pending", label: "Fachkraft in Anerkennung" },
  { value: "specialist", label: "Fachkraft" },
  { value: "nurse", label: "Pflegefachkraft" },
  { value: "nursing_assistant", label: "Pflegehilfskraft" },
  { value: "head_nurse", label: "Stationsleitung" },
  { value: "nursing_director", label: "Pflegedienstleitung" },
  { value: "physiotherapist", label: "Physiotherapeut" },
  { value: "midwife", label: "Hebamme" },
  { value: "medical_assistant", label: "Medizinische Fachangestellte" }
];

// New configurations for jobs
export const contractTypes: ContractType[] = [
  { value: "permanent", label: "Unbefristet" },
  { value: "temporary", label: "Befristet" },
  { value: "part_time", label: "Teilzeit" },
  { value: "training", label: "Ausbildungsvertrag" },
  { value: "probation", label: "Probezeit" },
  { value: "project_based", label: "Projektbezogen" }
];

export const benefits: Benefit[] = [
  { value: "tariff_salary", label: "Tarifliche Bezahlung" },
  { value: "above_tariff_salary", label: "Übertarifliche Bezahlung" },
  {
    value: "training_opportunities",
    label: "Fort- und Weiterbildungsmöglichkeiten"
  },
  { value: "30_days_vacation", label: "30 Tage Urlaub" },
  { value: "28_days_vacation", label: "28 Tage Urlaub" },
  { value: "company_pension", label: "Betriebliche Altersvorsorge" },
  { value: "flexible_hours", label: "Flexible Arbeitszeiten" },
  { value: "family_friendly", label: "Familienfreundliche Arbeitszeiten" },
  { value: "health_promotion", label: "Gesundheitsförderung" },
  { value: "free_drinks", label: "Kostenlose Getränke und Snacks" },
  { value: "team_events", label: "Team-Events" },
  { value: "job_ticket", label: "Jobticket für öffentliche Verkehrsmittel" },
  { value: "internal_training", label: "Interne Weiterbildungen" },
  { value: "company_kindergarten", label: "Betriebskindergarten" },
  { value: "sabbatical", label: "Sabbatical-Möglichkeiten" },
  { value: "modern_equipment", label: "Moderne Arbeitsplätze" },
  { value: "health_insurance", label: "Betriebliche Krankenversicherung" },
  { value: "free_parking", label: "Kostenlose Parkplätze" },
  { value: "shift_allowance", label: "Schichtzulagen" },
  { value: "employee_parking", label: "Kostenlose Mitarbeiterparkplätze" },
  { value: "friendly_atmosphere", label: "Familiäre Atmosphäre" },
  { value: "career_development", label: "Karriereentwicklung" },
  { value: "work_life_balance", label: "Work-Life-Balance" },
  { value: "modern_facilities", label: "Moderne Einrichtungen" },
  { value: "innovative_methods", label: "Innovative Behandlungsmethoden" }
];

export const requirements: Requirement[] = [
  {
    value: "nursing_degree",
    label: "Abgeschlossene Ausbildung als Pflegefachkraft"
  },
  { value: "elderly_care_degree", label: "Ausbildung in der Altenpflege" },
  {
    value: "nursing_exam",
    label: "Staatsexamen Gesundheits- und Krankenpflege"
  },
  {
    value: "physiotherapy_degree",
    label: "Abgeschlossene Ausbildung als Physiotherapeut"
  },
  { value: "midwife_degree", label: "Abgeschlossene Hebammenausbildung" },
  {
    value: "medical_assistant_degree",
    label: "Abgeschlossene Ausbildung als MFA"
  },
  { value: "german_b2", label: "Deutschkenntnisse B2 oder höher" },
  { value: "german_b1", label: "Deutschkenntnisse B1 oder höher" },
  { value: "teamwork", label: "Teamfähigkeit" },
  { value: "resilience", label: "Belastbarkeit" },
  { value: "empathy", label: "Einfühlungsvermögen" },
  { value: "flexibility", label: "Flexibilität" },
  { value: "experience_advantage", label: "Berufserfahrung von Vorteil" },
  {
    value: "intensive_care_experience",
    label: "Erfahrung auf Intensivstation von Vorteil"
  },
  { value: "cardiology_interest", label: "Interesse an Kardiologie" },
  {
    value: "rehabilitation_experience",
    label: "Erfahrung in der Rehabilitation"
  },
  { value: "communication_skills", label: "Empathie und Kommunikationsstärke" },
  { value: "patience", label: "Einfühlungsvermögen und Geduld" },
  { value: "shift_work_resilience", label: "Belastbarkeit im Schichtdienst" },
  { value: "practice_experience", label: "Erfahrung im Praxisbereich" },
  { value: "friendly_appearance", label: "Freundliches Auftreten" },
  { value: "computer_skills", label: "EDV-Kenntnisse" },
  { value: "midwife_experience", label: "Berufserfahrung erwünscht" },
  { value: "midwife_empathy", label: "Einfühlungsvermögen" }
];
